import React from "react";
import { matchPath } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, List, Link, Avatar, Drawer, Typography } from "@mui/material";
import { styled, alpha } from "@mui/system";
import NavItem from "./NavItem";
import useAuth from "../../contextapi/hooks/useAuth";
import NavSection from "../../components/nav-section";
import Img from "../../assets/img/avatar.png";
import Logo from "../../components/logo";
import bgImage from "../../assets/img/nav_nachos@2x.png";
import Scrollbar from "../../components/scrollbar";
import Menu from "@mui/icons-material/Menu";
import { makeStyles } from '@mui/styles';
import { Tooltip, Hidden, Button } from "@mui/material";

const StyledAccount = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

const renderNavItems = ({ items, pathname, depth = 0 }) => {
  return (
    <List
      disablePadding
      sx={{ p: 1 }}
      style={{ alignContent: "center", flex: 1, width: "100%" }}
    >
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
};

const reduceChildRoutes = ({ acc, pathname, item, depth }) => {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({ depth: depth + 1, pathname, items: item.items })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;
};
const useStyles = makeStyles(() => ({
  root: {
    background: "#051e34",
    // background: '-webkit-linear-gradient(59deg, #3A6073, #000000)',
    // background: 'linear-gradient(59deg, #3A6073, #000000)'
  },
  mobileDrawer: {
    width: 256,
    height: "100%",
  },
  desktopDrawer: {
    width: 256,
    height: "100%",
  },
  avatar: {
    cursor: "pointer",
    width: 100,
    height: 100,
  },
  textColor: {
    color: "#ffffff",
    fontSize: 15,
  },
  dividerColor: {
    backgroundColor: "#ffffff",
  },
  titleSections: {
    color: "white",
    fontSize: "0.6em",
    padding: "0.6em 0px",
    pointerEvents: "none",
    fontWeight: "600",
    letterSpacing: ".08em",
  },
  itemText: {
    fontSize: "10px !important",
  },
}));

const NavBar = ({ openNav, onCloseNav }) => {
  const classes = useStyles();
  const [image] = React.useState(bgImage);
  const [open, setOpen] = React.useState(false);
  const { user } = useAuth();

  const sectionsSuperAdmin = [
    {
      Estado: true,
      Orden: 1,
      id: "TwK9RcIjrUIcs9fF6lmW",
      Path: "/administrador/dashboard",
      Title: "Dashboard",
      Icon: "material-symbols:add-chart",
    },

    {
      Icon: "mdi:ev-station",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/puntocarga",
      Title: "Puntos de carga",
    },
    {
      Icon: "mdi:user-group-outline",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/usuarios",
      Title: "Usuarios",
    },
    {
      Icon: "mdi-bank",
      Estado: true,
      id: "szVahcmb12arecIKNF9lP",
      Orden: 9,
      Path: "/administrador/empresas",
      Title: "Empresas",
    },
    {
      Icon: "mdi-contact-mail",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/suscripciones",
      Title: "Suscripciones",
    },
    {
      Icon: "mdi:book",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/parametros",
      Title: "Parámetros",
    },
    {
      Icon: "mdi-comment-account",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/usuarios-externos",
      Title: "Usuarios externos",
    },
    {
      Icon: "mdi-language-html5",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/generador",
      Title: "Generador HTML",
    },
    {
      Icon: "mdi-monitor",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/monitoreo",
      Title: "Monitoreo",
    },
    
    {
      Icon: "mdi:car-electric",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/marcas",
      Title: "Marcas",
    },

    {
      Icon: "mdi:identification-card-outline",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/tipo-documento",
      Title: "Tipo documento",
    },

    {
      Icon: "mdi:family-tree",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/roles",
      Title: "Roles",
    },

    {
      Icon: "mdi:vector-bezier",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/status",
      Title: "Status",
    },

    {
      Icon: "bx:qr",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/qrgenerador",
      Title: "QR",
    },
  ];
  const sectionsAdmin = [
    {
      Estado: true,
      Orden: 1,
      id: "TwK9RcIjrUIcs9fF6lmW",
      Path: "/administrador/dashboard",
      Title: "Dashboard",
      Icon: "material-symbols:add-chart",
    },

    {
      Icon: "mdi:calendar-help-outline",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lP",
      Orden: 9,
      Path: "/administrador/puntocarga",
      Title: "Puntos de carga",
    },
  ];
  const sectionsEmpresas = [
    
    {
      Estado: true,
      Orden: 1,
      id: "TwK9RcIjrUIcs9fF6lmW",
      Path: "/administrador/dashboard",
      Title: "Dashboard",
      Icon: "material-symbols:add-chart",
    },
    {
      Icon: "mdi-account-plus",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lsdaP",
      Orden: 3,
      Path: "/administrador/socios",
      Title: "Socios clientes",
    },
    {
      Icon: "mdi-car-wash",
      Estado: true,
      id: "szVahcmbjcrecIKNF9lPas",
      Orden: 2,
      Path: "/administrador/vehiculo/" + user?.personId,
      Title: "Vehículos",
    },
 
    {
      Icon: "mdi-file-document",
      Estado: true,
      id: "szVahcmbjcdsdrecIKNF9lP",
      Orden: 4,
      Path: "/administrador/detail-parameter-user",
      Title: "Planes",
    },
 
    // {
    //   Icon: "mdi-file-chart",
    //   Estado: true,
    //   id: "szVahcmbjcdsdrecIKNF9lP",
    //   Orden: 4,
    //   Path: "/administrador/biblioteca",
    //   Title: "Biblioteca",
    // },

    
  ];
  const tipoMenu = (role) => {
    switch (role) {
      case "SUPER ADMIN": {
        return sectionsSuperAdmin;
      }
      case "ADMINISTRADOR": {
        return sectionsAdmin;
      }
      case "EMPRESA": {
        return sectionsEmpresas;
      }
    }
  };
  const content = (
    <Scrollbar
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundRepeat: "repeat",
        color: "#f5f5f5",
      }}
      sx={{
        height: 1,
        backgroundColor: "#05141F",
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: "inline-flex" }}>
        <Logo />
      </Box>
      <Link underline="none">
        <StyledAccount>
          <Avatar
            src={user.userPictureUrl != "" ? user.userPictureUrl : Img}
            alt="photoURL"
          />

          <Box sx={{ ml: 2 }}>
            <Typography variant="body2" sx={{ color: "#fff" }}>
              {user?.personFirstName} {user.personLastName}
            </Typography>
            <Typography variant="body2" sx={{ color: "#fff" }}>
              {user?.rolName}
            </Typography>
          </Box>
        </StyledAccount>
      </Link>

      <NavSection data={tipoMenu(user?.rolName)} />
    </Scrollbar>
  );
  return (
    <>
      <Hidden only="lg">
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          variant="temporary"
          open={open}
          onClose={() => setOpen(false)}
        >
          {content}
        </Drawer>
        <Tooltip title="Abrir menú lateral">
          <Button
            style={{
              position: "absolute",
              left: 10,
              top: 10,
              zIndex: 1100,
              backgroundColor: "#fff",
              color: "#051e34",
            }}
            onClick={() => setOpen(true)}
            variant="contained"
          >
            <Menu />
          </Button>
        </Tooltip>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.defaultProps = {
  onMobileNavOpen: () => {},
};
NavBar.propTypes = {
  image: PropTypes.string,
  openDrawer: PropTypes.bool,
  onMobileNavOpen: PropTypes.func,
};

export default NavBar;
